// src/axios/services/destino.js
import BaseService from "./baseService";

const destinoService = new BaseService("destino");

export default destinoService;
